<template>
  <div class="newscenterindex">
		<div class="contentTop">
			<banner></banner>
			<!-- <product></product> -->


			<div class="contentMiddle">
				<headerview></headerview>
				<div class="con_all">
					<div class="con_all_one">
						<tipsign :titleName="typeVal"></tipsign>
						<span>当前位置：{{typeVal}}>意见反馈</span>
					</div>
					
					<div class="con_all_two">
						<div class="list_a">
							<div class="divcar"><span>*</span>姓名</div>
							<el-input class="inputcar" v-model="username" placeholder="请输入姓名"></el-input>
							<div class="divcar"><span>*</span>性别</div>
							<el-select v-model="sex" placeholder="请选择" class="inputcar">
							    <el-option
							      v-for="item in options"
							      :key="item.value"
							      :label="item.label"
							      :value="item.value">
							    </el-option>
							</el-select>
							<!-- <el-input class="inputcar" v-model="sex" placeholder="请输入性别"></el-input> -->
						</div>
						
						<div class="list_a">
							<div class="divcar"><span>*</span>出生日期</div>
							<el-date-picker
								  class="inputcar"
							      v-model="birthday"
							      type="date"
							      placeholder="选择日期">
							</el-date-picker>
							<div class="divcar"><span>*</span>所在学校</div>
							<el-input class="inputcar" v-model="school" placeholder="请输入所在学校"></el-input>
						</div>
												
						<div class="list_b">
							<div class="divcar"><span>*</span>意见内容</div>
							<el-input
							  class="textareacar"
							  type="textarea"
							  :autosize="{ minRows: 6, maxRows: 10}"
							  placeholder="请输入意见内容"
							  v-model="suggestion">
							</el-input>
							<!-- <textarea v-model="suggestion" placeholder="请输入意见内容"></textarea> -->
						</div>
						
						<div class="list_c">
							<div class="submitBtn" @click="submitHeader">
								提交
							</div>
						</div>
					</div>
					
				</div>
			</div>				
								
		<footview></footview>

  </div>
  
 </div> 
</template>

<script>
import tipsign from "../../../components/tipsign/tipsign.vue";

export default {
  components: {
	 tipsign,
  },
  
  data() {
		return {
			typeVal:"小小主人翁",
			username:"",
			sex:"",
			school:"",
			suggestion:"",
			birthday:"",
			
			options: [{
			  value: '男',
			  label: '男'
			}, {
			  value: '女',
			  label: '女'
			}],
			// value: '',
					
		};
  },
  
  watch:{
		
  },

  
  mounted() {
		
  },
  
  
  methods: {
	  formatDate(date) {
	    var d = new Date(date),
	      month = '' + (d.getMonth() + 1),
	      day = '' + d.getDate(),
	      year = d.getFullYear();
	   
	    if (month.length < 2) month = '0' + month;
	    if (day.length < 2) day = '0' + day;
	   
	    return [year, month, day].join('-');
	  },
	  
	  submitHeader(){
		 if(this.username == ""){
			 this.$alert('姓名不能为空', '提示', {
			   confirmButtonText: '确定',
			   callback: action => {}
			 });
			 return;
		  }
		  if(this.sex == ""){
			 this.$alert('性别不能为空', '提示', {
			   confirmButtonText: '确定',
			   callback: action => {}
			 });
			 return;
		  }
		  if(this.school == ""){
				 this.$alert('所在学校不能为空', '提示', {
				   confirmButtonText: '确定',
				   callback: action => {}
				 });
				 return;
		  }
		  if(this.birthday == ""){
				 this.$alert('出生日期不能为空', '提示', {
				   confirmButtonText: '确定',
				   callback: action => {}
				 });
				 return;
		  }
		  if(this.suggestion == ""){
				 this.$alert('建议内容不能为空', '提示', {
				   confirmButtonText: '确定',
				   callback: action => {}
				 });
				 return;
		  }
		  if(this.suggestion.length >= 100){
				 this.$alert('建议内容不能超过100字', '提示', {
				   confirmButtonText: '确定',
				   callback: action => {}
				 });
				 return;
		  }			
		  let param = {
		  		userId: this.username,
		  		sex: this.sex,
				birthday:this.formatDate(this.birthday),
				school:this.school,
				suggestion:this.suggestion
		  };		  		  
		  this.$post(`web/opinionsuggest/add`,param).then(res=>{
		  	  if(res.success){
		  			// console.log(res)
		  			 this.$message({
		  				  message: '提交成功',
		  				  type: 'Warning'
		  			 });
					 this.username = "";
					 this.sex = "";
					 this.school = "";
					 this.suggestion = "";
					 this.birthday = "";
		  	  }
		  })  
		  
	  }
	  
	  
  }
  
};
</script>

<style scoped lang="scss">
	.newscenterindex{
		.contentTop{
			// background-image: linear-gradient(#FFFFFF, #E98257);
		}
		
		.contentMiddle{
			padding-top: 1.7rem;
			height: 12.2rem;
			// border: 1px solid #FFFFFF;		
			.con_all{
				height: 10rem;	
				margin: 0.1rem auto;
				// margin-left: 4rem;
				// margin-right: 4rem;
				width: 12.15rem;
				background: #FFFFFF;
				.con_all_one{
					height: 0.4rem;
					line-height: 0.4rem;
					padding-left: 0.2rem;
					border-bottom: 0.01rem solid #ededed;
					display: flex;
					justify-content: space-between;
					span{
						font-size: 0.16rem;
						margin-right: 0.2rem;
					}
				}
				.con_all_two{
					height: 5rem;
					width: 100%;
					// border: 1px solid red;
					margin-top: 0.4rem;
					.list_a{
						display: flex;
						align-items: center;
						margin-bottom: 0.4rem;
						font-size: 0.16rem;
						.divcar{
							width: 1rem;
							margin-left: 0.4rem;
							font-weight: bold;
							span{
								color: #FF0000;
							}
						}
						.inputcar{
							width: 2.6rem;
							height: 0.4rem;
						}
						
					}
					.list_b{
						display: flex;
						font-size: 0.16rem;
						.divcar{
							width: 1rem;
							margin-left: 0.4rem;
							font-weight: bold;
							span{
								color: #FF0000;
							}
						}
						.textareacar{
							width: 10rem;
							height: 1.87rem;
						}
					}
					.list_c{
						height: 2rem;
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						.submitBtn{
							cursor: pointer;
							width: 3.39rem;
							height: 0.5rem;
							line-height: 0.5rem;
							text-align: center;
							background: #E61F26;
							border-radius: 2px;
							font-size: 0.17rem;
							font-weight: 400;
							color: #FFFFFF;
						}
					}
				}
				
			}	
		}
			
			
		
		
	}
	
</style>
